import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function Vision({ theme }) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);          // ← ça force le scroll en haut
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Header */}
        <header className="mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Notre vision
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            Un outil honnête, transparent et construit avec vous
          </p>
        </header>

        {/* Intro */}
        <div className="prose dark:prose-invert max-w-none mb-16 text-lg leading-relaxed">
          <p>
            Beaucoup d’outils de suivi de portefeuille vous promettent la lune : tracking automatique, dizaines de graphiques, métriques à gogo, pour un prix non négligeable...
            Mais au final, vous ne savez pas toujours ce qui est vraiment stocké, comment c’est calculé, ni si vous pouvez récupérer vos données facilement.
          </p>
          <p>
            <strong>Nous avons choisi une autre voie : </strong>  
            des données aussi claires et maîtrisables qu’un fichier Excel, une transparence totale, et des analyses vraiment utiles, bien organisées, pensées pour les investisseurs de long terme.
          </p>
        </div>

        {/* Blocs principaux */}
        <div className="space-y-16">
          {/* Bloc Données */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-200 dark:border-gray-700">
            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
              Vos données vous appartiennent
            </h2>
            <ul className="space-y-4 text-gray-700 dark:text-gray-300 text-lg">
              <li>Historique 100 % traçable et limpide</li>
              <li>Import et export à tout moment (CSV, etc.)</li>
              <li>Si un jour vous voulez partir : un simple export et vous récupérez l’intégralité de votre historique, comme si vous l’aviez tenu dans Excel</li>
              <li>La saisie / mise à jour des données est gratuite — la vraie valeur est ailleurs</li>
            </ul>
          </div>

          {/* Bloc Analyses */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-200 dark:border-gray-700">
            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
              Des analyses riches… mais claires et organisées
            </h2>
            
            <p className="text-gray-700 dark:text-gray-300 mb-6 text-lg">
              Pas de surcharge d’indicateurs. On a regroupé les informations essentielles dans des vues claires et logiques, pensées pour les investisseurs de long terme :
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <ul className="space-y-3 text-gray-700 dark:text-gray-300">
                <li>Vue d’ensemble du portefeuille</li>
                <li>Comparaison avec benchmarks (MSCI World GR, CAC 40 GR, personnalisables…)</li>
                <li>Historique des transactions</li>
              </ul>
              <ul className="space-y-3 text-gray-700 dark:text-gray-300">
                <li>Performance individuelle par titre</li>
                <li>Répartition et diversification (secteurs, zones géographiques…)</li>
                <li>Analyse par compte / enveloppe</li>
                <li>Étude des stratégies (DCA, apports programmés…)</li>
              </ul>
            </div>
            <p className="text-gray-600 dark:text-gray-400 italic">
              Tout est présenté de façon progressive : on commence simple, on révèle la profondeur au fur et à mesure.
              Chaque section est réfléchie : un résumé clair en premier, puis l'état actuel du portefeuille, graphiques d’évolution, et enfin des comparaisons avec des références.
            </p>
          </div>

          {/* Bloc Collaboration */}
          <div className="bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-gray-800 dark:to-gray-900 rounded-2xl p-10 text-center">
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
              On construit ce dashboard ensemble
            </h2>
            <p className="text-xl text-gray-700 dark:text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
              Vous avez une idée de métrique qui vous manque ? Un graphique qui vous paraît pertinent ? Une présentation qui pourrait être améliorée ?
            </p>
            <p className="text-lg font-medium text-indigo-700 dark:text-indigo-400 mb-8">
              Dites-le-nous pour améliorer le produit.
            </p>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-10">
              Ensemble, construisons le logiciel de suivi de portefeuille le plus utile pour les investisseurs courageux français...
            </p>

            <button
              onClick={() => navigate('/')}
              className="px-8 py-4 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transform hover:scale-105 transition-all shadow-lg text-lg"
            >
              Retour à l’accueil
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vision;